module.exports = __webpack_public_path__ + "/static/assets/7b361b1ca1da53fffb88f8b0a8562890.gif";